/**
 * Created by godhh on 16/5/20.
 */

define((require, exports, module) => {
    // 构建大纲配置
    exports.buildOutlineOptions = function (content) {
        const outlineOptions = []
        let outlineCount = 1
        content = content.replace(/(<h[1-6])(.*?>)(.*?)(<\/h[1-6]>)/g, (match, p1, p2, p3, p4, offset, origin) => {
            // 去掉 <hx></hx> 标签，得到标题内容
            const title = match.replace(/<h[1-6].*?>(.*?)<\/h[1-6]>/g, '$1')
            // 去掉 标题内容 中的 标签，诸如 </br>、<img/>
            const titleContent = title.replace(/<.*?>/g,'')
            const id = `${titleContent}_${outlineCount}`

            if (titleContent) {
                outlineCount += 1
                outlineOptions.push({
                    titleContent,
                    // 简单保证id唯一
                    id,
                    level: p1.replace('<h', ''),
                })
            }

            return `${p1} id='${id}'${p2}${p3}${p4}`
        })

        return {
            outlineOptions,
            content,
        }
    }

    exports.tpl = function ($parent, content) {
        const { content: replaceContent } = exports.buildOutlineOptions(content)

        $parent.html(replaceContent)
    };
});



// WEBPACK FOOTER //
// ./src/js/detail_iframe_tpl.js